import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IdpHideElementOnTimeOutDirective } from './hide-element-on-time-out.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [IdpHideElementOnTimeOutDirective],
  exports: [IdpHideElementOnTimeOutDirective]
})
export class HideElementOnTimeOutModule {}
